module.exports = {["template-common-add-to-cart-wrap"]: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n	<div class="add-to-cart-wrap">\n		<div class="add-to-cart-attributes"></div>\n		<div class="add-to-cart-button"><div class="button-icon"></div></div>\n		<div class="sizes-calculating-block"></div>\n	</div>\n';
}
return __p;
},}